import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    PageContainerDynamicStyleType,
    PageContainerSizeConstantType
} from "./type";
import {
    type Mutable
} from "../../types";
import {
    webStyle
} from "../../utils";

export const PAGE_CONTAINER_SIZE_KEYS: Array<keyof ViewStyle> = [
    "flexBasis",
    "flexGrow",
    "height",
    "flex"
];

export const getIsPageContainerSized = ({
    style
}: PageContainerSizeConstantType): boolean => {
    const flatStyle: ViewStyle = StyleSheet.flatten(style) ?? {};

    return PAGE_CONTAINER_SIZE_KEYS.some((key) => flatStyle[key] !== undefined);
};

const stylesheet = StyleSheet.create({
    safeAreaViewContainer: {
        flex: 1
    },
    contentColumn: {
        alignSelf: "center",
        width: "100%",
        flexGrow: 1
    },
    container: {
        flex: 1
    }
});

export const useStyles = ({
    safeAreaViewBackgroundColor,
    isWorkWithHeaderSpace,
    backgroundColor,
    isCustomPadding,
    shapeConfigs,
    configs,
    colors,
    spaces
}: PageContainerDynamicStyleType) => {
    const styles = {
        safeAreaView: {
            backgroundColor: colors.content.container[safeAreaViewBackgroundColor ?? backgroundColor]
        } as Mutable<ViewStyle>,
        content: {
            padding: spaces.spacingLg,
            paddingTop: spaces.spacingLg + (isWorkWithHeaderSpace ? configs.headerSpace : 0)
        } as Mutable<ViewStyle>,
        container: {
            backgroundColor: colors.content.container[backgroundColor],
            ...webStyle({
                scrollbarGutter: "stable"
            })
        } as Mutable<ViewStyle>,
        contentColumn: {
            maxWidth: shapeConfigs.contentMaxWidth
        } as Mutable<ViewStyle>
    };

    if(isCustomPadding) {
        delete styles.content.paddingTop;
        delete styles.content.padding;
    }

    return styles;
};
export default stylesheet;
